export default {
    data() {
        return {
            observer: {},
            exposeTimer: {},
            trackExposeCustom: {}
        };
    },
    props: {
        needTrackExpose: {
            type: Boolean,
            default: true
        }
    },
    mounted() {
        if (!this.needTrackExpose) {
            return;
        }
        this.observer = new IntersectionObserver(this.trackExposeCallBack, {
            rootMargin: '0px',
            threshold: 0.5
        });
        this.observer.observe(this.$el);
    },
    beforeDestroy() {
        if (this.observer && this.observer.unobserve) {
            this.observer.unobserve(this.$el);
        }
    },
    methods: {
        trackExposeCallBack(val) {
            if (!val[0]) return;
            if (val[0].isIntersecting) {
                this.exposeTimer = setTimeout(() => {
                    this.trackExposeAction();
                }, 1000);
            } else {
                clearTimeout(this.exposeTimer);
            }
        },
        trackExposeAction() {
            this.$emit('trackExposeAction', this.trackExposeCustom);
        }
    }
};



// WEBPACK FOOTER //
// ./src/views/marketing/mixin/track-expose.js